// UTM & referrer capture — persist first-touch attribution for the whole session.
const KEY = "ef_attr_v1";
const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];

function safeParseParams(search) {
  try {
    return new URLSearchParams(search || "");
  } catch {
    return new URLSearchParams();
  }
}

export function captureAttribution() {
  if (typeof window === "undefined") return;
  const params = safeParseParams(window.location.search);
  const fromUrl = {};
  UTM_KEYS.forEach((k) => {
    const v = params.get(k);
    if (v) fromUrl[k] = v.slice(0, 200);
  });

  // read existing (first-touch wins)
  let existing = {};
  try {
    existing = JSON.parse(sessionStorage.getItem(KEY) || "{}");
  } catch {
    existing = {};
  }

  const referrer = existing.referrer || (document.referrer || "").slice(0, 500) || null;
  const landing_page = existing.landing_page || `${window.location.pathname}${window.location.search || ""}`.slice(0, 500);

  const merged = { ...existing };
  UTM_KEYS.forEach((k) => {
    if (existing[k]) return;
    if (fromUrl[k]) merged[k] = fromUrl[k];
  });
  if (referrer && !merged.referrer) merged.referrer = referrer;
  if (!merged.landing_page) merged.landing_page = landing_page;

  try {
    sessionStorage.setItem(KEY, JSON.stringify(merged));
  } catch {}
  return merged;
}

export function getAttribution() {
  if (typeof window === "undefined") return {};
  try {
    return JSON.parse(sessionStorage.getItem(KEY) || "{}");
  } catch {
    return {};
  }
}
